import elementHelper from '@lib/utils/elementHelper'
import { baiduAutomaticPush } from './baiduAutomaticPush' // 百度推送代码,seo

/*
 * 三种统计，gio,baidu,google 初始化，目前gio统计比较复杂
 */
function init(_key) {
  baiduInit(_key)
  baiduAutomaticPush()
}

function baiduInit(_key) {
  window._hmt = window._hmt || []
  elementHelper.dynamicAddScript('https://hm.baidu.com/hm.js?' + _key)
}
// //直接初始化
// init()
export default {
  init
}
